'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _stateList = _interopRequireDefault(require("../state-list"));

var _translate = _interopRequireDefault(require("../translate"));

var _formatDate = require("../../lib/format-date");

var _authorisation = _interopRequireDefault(require("../authorisation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var UserState = /*#__PURE__*/function (_React$Component) {
  _inherits(UserState, _React$Component);

  function UserState(props) {
    var _this;

    _classCallCheck(this, UserState);

    _this = _possibleConstructorReturn(this, (UserState.__proto__ || Object.getPrototypeOf(UserState)).call(this, props));
    _this.state = {
      data: {
        checkedUser: {}
      },
      isLoading: false
    };
    _this.staticTexts = {
      noData: props.t('no data'),
      loading: props.t('loading data')
    };
    _this.transformData = _this.transformData.bind(_assertThisInitialized(_this));
    _this.updateUserInfo = _this.updateUserInfo.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   *
   */


  _createClass(UserState, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadData();
      this.setState(function (prev) {
        prev.isLoading = true;
        return prev;
      });
    }
    /**
     *
     * @returns {*}
     */

  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: 'comp-user-state'
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: "status"
      }, t('release status')), /*#__PURE__*/_react.default.createElement(_stateList.default, {
        isLoading: this.state.isLoading,
        staticTexts: this.staticTexts,
        data: this.transformData(this.props.userData, this.state.data),
        projectKey: ''
      }));
    }
    /**
     *
     * @param userData
     * @param userStateData
     * @returns {[]}
     */

  }, {
    key: "transformData",
    value: function transformData(userData, userStateData) {
      var isEmailVerified,
          rowData = []; // Email verified

      isEmailVerified = userData ? userData.email_verified : false;
      var EmailState = {
        type: 'email-verified',
        subject: this.props.t('email address'),
        state: {
          icon: isEmailVerified ? 'icon-check' : 'icon-close',
          color: isEmailVerified ? 'green' : 'red'
        }
      };
      rowData.push(EmailState);
      var checkedBy = userStateData.checked_by ? userStateData.checked_by : false;
      var state = {
        type: 'user-checked',
        subject: this.props.t('checked'),
        state: {
          icon: checkedBy ? 'icon-check' : 'icon-close',
          color: checkedBy ? 'green' : 'red'
        },
        info1: {
          icon: 'icon-user',
          text: userStateData.checkedUser.email
        },
        info2: {
          icon: 'icon-date',
          text: (0, _formatDate.formatDate)(userStateData.checked_at)
        }
      };

      if (!checkedBy) {
        var CheckUserButtonAuthorised = new _authorisation.default(['admin'], [], false)( /*#__PURE__*/_react.default.createElement("button", {
          className: "btn btn--small",
          onClick: this.updateUserInfo
        }, this.props.t('checked')));
        delete state.info2;

        state.info1 = function () {
          return /*#__PURE__*/_react.default.createElement(CheckUserButtonAuthorised, null);
        };
      }

      rowData.push(state);
      return rowData;
    }
  }, {
    key: "loadData",
    value: function loadData() {
      var _this2 = this;

      fetch("/api/".concat(this.props.i18n.language, "/administration/user/").concat(this.props.userId), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (result) {
        _this2.setState(function (prev) {
          prev.data = result.body;
          prev.isLoading = false;
          return prev;
        });
      }).catch(function (err) {
        void 0;
      });
    }
  }, {
    key: "updateUserInfo",
    value: function updateUserInfo() {
      var _this3 = this;

      fetch("/api/".concat(this.props.i18n.language, "/administration/user/").concat(this.props.userId, "/check"), {
        credentials: 'include',
        method: 'POST'
      }).then(_fetchUtils.default.checkStatus).then(function (result) {
        _this3.setState(function (prev) {
          prev.data = result.body;
          return prev;
        });
      }).catch(function (err) {
        void 0;
      });
    }
  }]);

  return UserState;
}(_react.default.Component);

UserState.propTypes = {
  t: _propTypes.default.any.isRequired,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  userId: _propTypes.default.string.isRequired,
  userData: _propTypes.default.object.isRequired
};

var _default = (0, _translate.default)(UserState);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/user-state/index.js
// module id = 741
// module chunks = 0